const popUpPreview = {
  namespaced:true,
  state(){
    return {
      isTop:true,
      isList:false,
      listType:1,
      projectType:1,
      buttonProjectType:1,
      isButton:false,
      isBottom:false,
      topImgUrl:'../static/img/bg.png',
      topImgUrlHref:'',
      listData:[],
      listButtonText:{
        receive:"collect",
        received:"collected"
      },
      buttomImgUrl:'',
      bottomImgHref:'',
      buttonData:{
        color:"#40A9FF",
        type:"2",
        act_code:"",
        goodsCode:"",
        goodsHref:"",
      },
    }
  },
  getters:{
    data(state){
      return state;
    }
  },
  mutations: {
    SET_TOP_IMAGES_URL: (state,topImgUrl) => {
      state.topImgUrl = topImgUrl;
    },
    SET_TOP_IMAGES_HREF: (state,topImgUrlHref) => {
      state.topImgUrlHref = topImgUrlHref;
    },
    SET_LIST_DATA: (state,listData) => {
      state.listData = listData;
    },
    SET_LIST_BUTTON_TEXT: (state,listButtonText) => {
      state.listButtonText = listButtonText;
    },
    SET_BUTTOM_IMAGES_URL: (state,buttomImgUrl) => {
      state.buttomImgUrl = buttomImgUrl;
    },
    SET_BOTTOM_IMAGES_HREF: (state,bottomImgHref) => {
      state.bottomImgHref = bottomImgHref;
    },
    SET_BUTTON_DATA: (state,buttonData) => {
      state.buttonData = buttonData;
    },
    SET_IS_TOP:(state,isTop) => {
      state.isTop = isTop;
    },
    SET_IS_LIST:(state,isList) => {
      state.isList = isList;
    },
    SET_LIST_TYPE:(state,listType) => {
      state.listType = listType;
    },
    SET_PROJECT_TYPE:(state,projectType) => {
      state.projectType = projectType;
    },
    SET_BUTTON_PROJECT_TYPE:(state,buttonProjectType) => {
      state.buttonProjectType = buttonProjectType;
    },
    SET_IS_BUTTON:(state,isButton) => {
      state.isButton = isButton;
    },
    SET_IS_BOTTOM:(state,isBottom) => {
      state.isBottom = isBottom;
    },
    SET_STATE:(state,opt)=>{
      for(let [key,val] of Object.entries(opt)){
        state[key] = val;
      }
    }
  },

  actions: {
    set_top_images: ({ commit }, topImgUrl) => {
      commit('SET_TOP_IMAGES_URL',topImgUrl)
    },
    set_top_images_href: ({ commit }, topImgUrlHref) => {
      commit('SET_TOP_IMAGES_HREF',topImgUrlHref)
    },
    set_list_data: ({ commit }, listData) => {
      commit('SET_LIST_DATA',listData)
    },
    set_list_button_text: ({ commit }, listButtonText) => {
      commit('SET_LIST_BUTTON_TEXT',listButtonText)
    },
    set_buttom_images: ({ commit }, buttomImgUrl) => {
      commit('SET_BUTTOM_IMAGES_URL',buttomImgUrl)
    },
    set_bottom_images_href: ({ commit }, bottomImgHref) => {
      commit('SET_BOTTOM_IMAGES_HREF',bottomImgHref)
    },
    set_button_data: ({ commit }, buttonData) => {
      commit('SET_BUTTON_DATA',buttonData)
    },
    set_is_top:({ commit }, isTop) => {
      commit('SET_IS_TOP',isTop)
    },
    set_is_list:({ commit }, isList) => {
      commit('SET_IS_LIST',isList)
    },
    set_list_type:({ commit }, listType) => {
      commit('SET_LIST_TYPE',listType)
    },
    set_project_type:({ commit }, projectType) => {
      commit('SET_PROJECT_TYPE',projectType)
    },
    set_button_project_type:({ commit }, buttonProjectType) => {
      commit('SET_BUTTON_PROJECT_TYPE',buttonProjectType)
    },
    set_is_button:({ commit }, isButton) => {
      commit('SET_IS_BUTTON',isButton)
    },
    set_is_bottom:({ commit }, isBottom) => {
      commit('SET_IS_BOTTOM',isBottom)
    },
    set_state:({commit},data)=>{
      commit('SET_STATE',data)
    }
  }
}

export default popUpPreview



// WEBPACK FOOTER //
// ./src/store/popUpPreview.js